// src/components/RegisterModal/RegisterModal.jsx
import React from 'react';
import '../design/RegisterModal.css';

export default function RegisterModal({
  isOpen,
  onClose,
  openLogin,
  openInvestor,
  openBrand,
  openPartner,
  openLeasing
}) {
  if (!isOpen) return null;

  return (
    <div className="login-modal-overlay">
      {/* Backdrop closes modal when clicked outside */}
      <div className="login-modal-backdrop" onClick={onClose}></div>
      <div className="login-modal-box">
        
        {/* Left Panel: High-Impact Value Proposition (Desktop Only) */}
        <div className="why-register">
          <h4 className="panel-title">Franmax: Your Gateway to India's Growth</h4>
          
          <ul className="value-list">
            <li>
              <span className="icon">✓</span>
              Find Opportunity: Instantly connect with top franchisors, qualified investors, and prime commercial properties.
            </li>
            <li>
              <span className="icon">✓</span>
              Maximize Growth: Tools and resources tailored for Brands to expand and Investors to achieve high returns.
            </li>
            <li>
              <span className="icon">✓</span>
              Trusted Network: Join India's largest, most reliable marketplace for business expansion and commercial leasing.
            </li>
          </ul>
          <p className="callout-text">
            Choose your pathway to success and start your journey today.
          </p>
        </div>

        {/* Right Panel: Registration Options */}
        <div className="login-form-content">
          <button className="close-modal-btn" onClick={onClose}>✖</button>
          <h3 className="login-title">Welcome, Register Here</h3>

          <div className="register-options-body">
            
            <button className="modal-option" onClick={() => { onClose(); openInvestor(); }}>
              Start Your Own Business Today<br />
              <span>(Investor Registration)</span>
            </button>

            <button className="modal-option" onClick={() => { onClose(); openBrand(); }}>
              Expand Your Brand<br />
              <span>(Franchisor Registration)</span>
            </button>

            <button className="modal-option" onClick={() => { onClose(); openPartner(); }}>
              Become Our Partner<br />
              <span>(IBP Registration)</span>
            </button>

            <button className="modal-option" onClick={() => { onClose(); openLeasing(); }}>
              Lease Your Property<br />
              <span>(Leasing Registration)</span>
            </button>

            <p className="register-text">
              Already registered?{' '}
              <a href="/" onClick={(e) => {
                e.preventDefault();
                onClose();
                openLogin();
              }}>
                Login here
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}